// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5339":"5af0f521","6346":"b72a8383"}[chunkId] + ".chunk.css";
};